import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IApiToken } from '../types/IApiToken';

export class CreateApiTokenRequest extends Request<Object, any> {
  constructor(clientName: string) {
    super('createApiToken', {'apiToken' : <IApiToken>{'clientName' : clientName}});
  }
}
